var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalidMeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 285,
    viewBox: "0 0 289 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.015 33.5525L254.886 199.007C258.988 205.67 254.194 214.25 246.37 214.25H42.6299C34.8057 214.25 30.0123 205.67 34.1145 199.007L135.985 33.5525C139.89 27.2097 149.11 27.2097 153.015 33.5525Z",
    stroke: "#FF0000",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.751 80.9091L150.686 159.318H138.328L137.262 80.9091H151.751ZM144.507 190.852C141.879 190.852 139.624 189.911 137.742 188.029C135.86 186.147 134.919 183.892 134.919 181.264C134.919 178.636 135.86 176.381 137.742 174.499C139.624 172.617 141.879 171.676 144.507 171.676C147.134 171.676 149.389 172.617 151.272 174.499C153.154 176.381 154.095 178.636 154.095 181.264C154.095 183.004 153.651 184.602 152.763 186.058C151.911 187.514 150.757 188.686 149.301 189.574C147.88 190.426 146.282 190.852 144.507 190.852Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidMeal);
export default __webpack_public_path__ + "static/media/invalidMeal.2e40ea6cc20ff8c46470657b1c8da8f4.svg";
export { ForwardRef as ReactComponent };